export const DialogAssignCarriersConstants = {
  ASSOCIATE_CARRIER_ICON: '../../../../assets/illustration-associate.svg',
  CONFIRM: 'Confirm',
  MODAL_ICON: '../../../assets/assign-warning.png',
  MODAL_SIZE: '650px'
};
